export const DISABLED_TOOTH_OPACITY = 0.3;
